module.exports = "/assets/58ff44db895e30f62169aea824985a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AY.png
// module id = 2341
// module chunks = 0